import * as Mutation from './mutation-types'

export default {
  [Mutation.GET_AGENDA](state, agenda) {
    return state.agenda = agenda
  },
  [Mutation.START_LOADING](state) {
    return state.loading = true
  },
  [Mutation.STOP_LOADING](state) {
    return state.loading = false
  },
  [Mutation.SET_CURRENT_DAY](state, currentDay) {
    return state.currentDay = currentDay
  },
  [Mutation.SET_DATE_RANGE](state, dateRange) {
    return state.dateRange = dateRange
  },
  [Mutation.DELETE_CRONOGRAMA](state, cronogramaId) {
    return state.agenda = state.agenda.filter(cronograma => cronograma.id !== cronogramaId)
  },
  [Mutation.REMOVE_EVENT_DAY](state, eventDayId) {
    let agenda = state.agenda
    agenda.forEach(schedule => {
      schedule.eventos_agenda = schedule.eventos_agenda.filter(event => event.id !== eventDayId)
    })

    return state.agenda = agenda
  },
  [Mutation.UPDATE_SCHEDULE_DATES](state, scheduleId) {
    let agenda = state.agenda
    const scheduleIndex = agenda.findIndex(schedule => schedule.id === scheduleId)

    const scheduleEventsNumber = agenda[scheduleIndex].eventos_agenda.length
    agenda[scheduleIndex].data_inicio = agenda[scheduleIndex].eventos_agenda[0].data_inicio
    agenda[scheduleIndex].data_fim = agenda[scheduleIndex].eventos_agenda[scheduleEventsNumber - 1].data_fim

    return state.agenda = agenda
  },
}
